const React = require("react");

const useId = require('@reach/auto-id').useId;

function DoneCircleIcon(props, svgRef) {
  const id = "DoneCircleIcon" + '_' + useId();
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm3.663 7.251a1 1 0 00-1.412.086l-3.318 3.745-1.19-1.319-.09-.088a1 1 0 00-1.395 1.428l1.94 2.15.09.088a1 1 0 001.402-.095l4.059-4.583.077-.099a1 1 0 00-.163-1.313z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(DoneCircleIcon);
const MemoForwardRef = React.memo(ForwardRef);
module.exports = MemoForwardRef;